"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function isSubtleCryptoAvailable() {
  return typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined';
}

exports.isSubtleCryptoAvailable = isSubtleCryptoAvailable;

function isNodeCryptoAvailable(withFeature) {
  try {
    var resolvedResult = require.resolve('crypto');

    if (!resolvedResult) {
      return false;
    } // eslint-disable-next-line import/no-nodejs-modules,no-restricted-modules,global-require


    var cryptoModule = require('crypto');

    if (!cryptoModule) {
      return false;
    }

    if (withFeature) {
      var features = withFeature(cryptoModule);
      return features;
    }

    return true;
  } catch (error) {
    return false;
  }
}

exports.isNodeCryptoAvailable = isNodeCryptoAvailable;
exports.NO_CRYPTO_LIB = 'Crypto lib not found. Either the WebCrypto "crypto.subtle" or Node.js "crypto" module must be available.'; // Make async for future version which may lazy load.
// eslint-disable-next-line @typescript-eslint/require-await

function getCryptoLib() {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var nodeCrypto;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isSubtleCryptoAvailable()) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              lib: crypto.subtle,
              name: 'subtleCrypto'
            });

          case 4:
            _context.prev = 4;
            // eslint-disable-next-line max-len
            // eslint-disable-next-line import/no-nodejs-modules,no-restricted-modules,global-require,@typescript-eslint/no-var-requires
            nodeCrypto = require('crypto');
            return _context.abrupt("return", {
              lib: nodeCrypto,
              name: 'nodeCrypto'
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](4);
            throw new Error(exports.NO_CRYPTO_LIB);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 9]]);
  }));
}

exports.getCryptoLib = getCryptoLib;